
import AskQuestion from "./AskQuestion";
import FreePhoneCall from "./FreePhoneCall";
;

function Forms(props) {
    const {default_category, uuid, if_WK} = props

    return (
        <div className="container">
            <div className="row homepage-forms-container">
                <section className={`${if_WK ? 'col-md-10' : 'col-md-6'}`} style={{margin: `${if_WK ? '0 auto' : ''}`}}>
                    <AskQuestion uuid={uuid} default_category={default_category} if_WK={if_WK}/>
                </section>
                {!if_WK ?
                    <section className="col-md-6">
                        <FreePhoneCall />
                    </section>
                : null
                }
                
            </div>
        </div>
    )
}

export default Forms;